module.exports = __webpack_public_path__ + "img/17761e3.png";